// 替换页面上的所有 luxotic/Luxotic 为 LUXOTIC
(function() {
  function replaceText(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent;
      // 匹配 luxotic 或 Luxotic，但排除全大写的 LUXOTIC
      const replaced = text.replace(/(?<!LUXOTIC)luxotic|Luxotic/gi, 'LUXOTIC');
      if (replaced !== text) {
        node.textContent = replaced;
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      // 跳过 script 和 style 标签
      if (node.tagName !== 'SCRIPT' && node.tagName !== 'STYLE') {
        node.childNodes.forEach(replaceText);
      }
    }
  }

  // 初始替换
  replaceText(document.body);

  // 监听新节点插入（处理动态内容）
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach(replaceText);
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
